import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../../context/AuthContext';
import { createInquiry, INQUIRY_TYPES } from '../../../services/inquiryService';

const InquiryNew = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const [category, setCategory] = useState('');
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const canSubmit = category && title.trim() && body.trim() && !submitting;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userData?.uid) {
      alert('로그인이 필요합니다.');
      return;
    }
    setSubmitting(true);
    try {
      await createInquiry({
        realtorId: userData.uid,
        realtorName: userData.name || '',
        type: category,
        title: title.trim(),
        content: body.trim(),
      });
      alert('문의가 등록되었습니다. 답변은 알림으로 안내드리겠습니다.');
      navigate('/realtor/inquiry');
    } catch (err) {
      console.error('문의 등록 실패:', err);
      alert('문의 등록에 실패했습니다. 잠시 후 다시 시도해주세요.');
      setSubmitting(false);
    }
  };

  return (
    <Wrap>
      <Card>
        <Form onSubmit={handleSubmit}>
          <Field>
            <Label>문의 유형</Label>
            <Select value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="">선택해주세요</option>
              {INQUIRY_TYPES.map((t) => (
                <option key={t.key} value={t.key}>{t.label}</option>
              ))}
            </Select>
          </Field>
          <Field>
            <Label>제목</Label>
            <Input
              placeholder="문의 제목을 입력해주세요"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Field>
          <TextareaField>
            <Label>내용</Label>
            <Textarea
              placeholder="문의 내용을 상세히 작성해주세요"
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </TextareaField>
          <SubmitBtn type="submit" disabled={!canSubmit}>{submitting ? '등록 중...' : '문의 등록'}</SubmitBtn>
        </Form>
      </Card>
    </Wrap>
  );
};

export default InquiryNew;

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 52px - 76px - 32px);
`;

const Card = styled.div`
  background: ${({ theme }) => theme.colors.bgWhite};
  border-radius: ${({ theme }) => theme.radius.lg};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  padding: ${({ theme }) => theme.spacing.lg};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Form = styled.form`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Field = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.base};
`;

const Label = styled.label`
  display: block;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 6px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: ${({ theme }) => theme.fontSize.sm};
  min-height: 48px;
  outline: none;
  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: ${({ theme }) => theme.fontSize.sm};
  min-height: 48px;
  outline: none;
  background: #fff;
  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const TextareaField = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.base};
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: ${({ theme }) => theme.fontSize.sm};
  flex: 1;
  min-height: 120px;
  resize: none;
  outline: none;
  line-height: 1.5;
  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const SubmitBtn = styled.button`
  width: 100%;
  padding: 14px;
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  border: none;
  border-radius: ${({ theme }) => theme.radius.pill};
  min-height: 48px;
  margin-top: ${({ theme }) => theme.spacing.sm};
  cursor: pointer;
  white-space: nowrap;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
